import React from 'react';
import { BoxSecondary } from './style';

interface Props {
    children: JSX.Element[] | JSX.Element;
}

const Box: React.FC<Props> = ({ children }) => (
    <BoxSecondary className="box">{children}</BoxSecondary>
);

export default Box;
